import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f651792"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索名称")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("搜索说明")
const _hoisted_13 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_14 = { class: "card-body table-responsive p-0" }
const _hoisted_15 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_16 = { ref: "tableTr" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "businessStatus" }, "状态", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "startUser" }, "发起人", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "processDefinitionName" }, "流程模版", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "startTime" }, "任务开始时间", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "totalDuration" }, "整体耗时", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "taskCreatedTime" }, "节点开始时间", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "nodeDuration" }, "节点耗时", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "currentActivityName",
  class: "normal-width text-left"
}, "当前节点", -1))
const _hoisted_27 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["colspan"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_31 = { class: "table-btn-group" }
const _hoisted_32 = { class: "btn-group" }
const _hoisted_33 = { class: "badge bg-light font-weight-normal align-super" }
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_36 = { class: "content-modal" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_button_tooltip = _resolveComponent("app-button-tooltip")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_ProcessWorkspace = _resolveComponent("ProcessWorkspace")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/flowable/workspace/copy/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/flowable/workspace/copy/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/flowable/workspace/copy/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      _hoisted_10,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchFunction('org_type_name')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_11
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('org_type_remark')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_12
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[7] || (_cache[7] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.Auth('/flowable/workspace/copy/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_16, _hoisted_27, 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_30
                          ], 8, _hoisted_29)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.templateId,
                        class: _normalizeClass({'text-red': parseInt(item.templateStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            (_ctx.Auth('/flowable/workspace/copy/processFlow'))
                              ? (_openBlock(), _createBlock(_component_app_button_tooltip, {
                                  key: 0,
                                  content: "流程处理",
                                  onBtnClick: $event => (_ctx.flowProcessing(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { name: "process-fill" })
                                  ]),
                                  _: 2
                                }, 1032, ["onBtnClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$tools.formatBusinessStatus(item.businessStatus)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.startUser.title), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(item.processDefinitionName) + " ", 1),
                          _createElementVNode("span", _hoisted_33, "v" + _toDisplayString(item.processDefinitionVersion), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.startTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.totalDuration), 1),
                        _createElementVNode("td", null, _toDisplayString(item.taskCreatedTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.nodeDuration), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(item.currentActivityName), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_36, [
      _createVNode(_component_ProcessWorkspace, {
        ref: "processView",
        onFlowSubmit: _ctx.onFlowSubmit
      }, null, 8, ["onFlowSubmit"])
    ])
  ]))
}